namespace RedBullMOBILE360.Utilities {
    export namespace ReAuthenticateNumbersService {
        export const baseUrl = 'Utilities/ReAuthenticateNumbers';

        export declare function Create(request: Serenity.SaveRequest<ReAuthenticateNumbersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReAuthenticateNumbersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReAuthenticateNumbersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReAuthenticateNumbersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExcelImport(request: BulkSMS.MessageExcelFile, onSuccess?: (response: Serenity.Extensions.ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Utilities/ReAuthenticateNumbers/Create",
            Update = "Utilities/ReAuthenticateNumbers/Update",
            Delete = "Utilities/ReAuthenticateNumbers/Delete",
            Retrieve = "Utilities/ReAuthenticateNumbers/Retrieve",
            List = "Utilities/ReAuthenticateNumbers/List",
            ExcelImport = "Utilities/ReAuthenticateNumbers/ExcelImport"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ExcelImport'
        ].forEach(x => {
            (<any>ReAuthenticateNumbersService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
